import Microapp from '@/components/micro-app';
import env from '@/env';

export default () => {
  return <Microapp url={`${env.BAICHUAN_DOMAIN}`} name="bc" />;
};
